import { ReadonlyDetail } from '@/common/components/employees/shared/ReadonlyDetail';
import { useEmployeeDetailContext } from '@/common/contexts/EmployeeDetailContext';

export const BankDetails = () => {
  const { employeeDetail } = useEmployeeDetailContext();

  return (
    <div className="mb-6">
      <div className="mb-4 font-semibold">Bank</div>
      <fieldset className="form-fieldset">
        <ReadonlyDetail label="Bank Country">{employeeDetail.personalInformation.bankCountryCode}</ReadonlyDetail>
        <ReadonlyDetail label="Bank Name">{employeeDetail.personalInformation.bankName}</ReadonlyDetail>
        <ReadonlyDetail label="Branch Name">{employeeDetail.personalInformation.branchName}</ReadonlyDetail>
        <ReadonlyDetail label="Account Number">{employeeDetail.personalInformation.accountNumber}</ReadonlyDetail>
        <ReadonlyDetail label="Account Holder Name">
          {employeeDetail.personalInformation.accountHolderName}
        </ReadonlyDetail>
      </fieldset>
    </div>
  );
};
